import { AxiosError, AxiosResponse } from 'axios'
import { toast } from 'react-toastify'

export function setupAxios(axios: any, logout: any, refresh: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: { headers: { Authorization: string } }) => {
      const token = localStorage.getItem('accessToken')
      if (token) config.headers.Authorization = `Bearer ${token}`
      return config
    },
    (err: any) => Promise.reject(err)
  )
  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      if (response?.data?.data?.created === false)
        toast.warn('Record already exists')
      else response?.data?.message && toast.success(response?.data?.message)
      return response?.data?.data
    },
    async (error: AxiosError) => {
      if (process.env.NODE_ENV === 'development') console.log(error.response)
      const refresh_token = localStorage.getItem('refreshToken')
      const originalRequest: any = error.config
      if (
        error?.response?.status === 403 &&
        refresh_token &&
        !originalRequest._retry
      ) {
        try {
          originalRequest._retry = true
          await refresh()
          return axios(originalRequest)
        } catch (error) {
          logout()
        }
      } else if (error?.response?.status === 401) {
        logout()
      } else {
        const data: any = error?.response?.data
        if (data?.message) {
          let message = data?.message
          if (error?.response?.status === 422 && Array.isArray(data.data))
            message = data.data[0]?.path + ': ' + data.data[0]?.msg
          toast.error(message)
        }
        throw error
      }
    }
  )
}
